export const SET_ALL = 'sponsors/SET_ALL';
export const SET_BY_ID = 'sponsors/SET_BY_ID';
